<template>
  <v-flex row class="pl-block pl__linkRow">
    <a @click="returnToBack" class="pl-link_back">
      <v-icon class="pl-button__icon"> chevron_left </v-icon>
      {{ linkBackText }}
    </a>
  </v-flex>
</template>

<script>
export default {
  name: 'Back',
  props: {
    linkBack: {
      required: true,
    },
    linkBackText: {
      required: true,
      default: 'Назад к списку',
    },
    routerPush: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    returnToBack() {
      if (window.history.length < 3 || this.routerPush) {
        this.$router.push({ path: this.linkBack })
      } else {
        if (this.linkBack === '/employers' || this.linkBack === '/companies') window.history.go(-1)
        // харкод но мне уже похуй
        else window.history.go(-2) //т.к. у нас в каждой карточке сетится таб в урл
      }
    },
  },
}
</script>
